import ColorPicker from './ColorPicker';
import { AggregationColor } from './color';
export { AggregationColor };
export default ColorPicker;
